import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestHeadCountDetailsList(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/reports/getheadCountDetails`);
  } else {
    return fetch.post(
      `${BASE_URL}/api/app/reports/getheadCountDetails`,
      params
    );
  }
}

export function requestUpdateLocationAreaDetails(data) {
  return fetch.post(
    `${BASE_URL}/api/app/location-area-details/updateLocationAreaDetails`,
    data
  );
}
